import { render } from "./ActSurvey.vue?vue&type=template&id=6f0856ca"
import script from "./ActSurvey.vue?vue&type=script&lang=js"
export * from "./ActSurvey.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__